import { extendTheme } from "@chakra-ui/react";

const ChakraTheme = extendTheme({
  styles: {
    global: {
      body: {
        bg: "#f8f8f8",
      },
    },
  },
  fonts: {
    heading: "Inter, sans-serif",
    body: "Inter, sans-serif",
  },
  colors: {
    brand: "#6ca2d8",
    grey: "#ededed",
    secondary: "#cde6ff",
  },
  components: {
    Progress: {
      baseStyle: {
        filledTrack: {
          bg: "#6ca2d8",
        },
      },
    },
  },
});

export default ChakraTheme;
